module.exports = __webpack_public_path__ + "img/icon-生物@2x.34eb710b.png";